class Ftm {
    constructor(apiService = null) {
        this.obj_name = 'ftm';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 送出前檢查表單填寫格式
    checkFtmModel(formData) {
        const validations = [
            { condition: formData.acknowledgment_id === null, message: '受理單編號遺失' },
            { condition: formData.medical_record_id === null, message: '病歷單遺失' },
            { condition: formData.doctor_id === -1, message: '請選擇檢傷醫師' },
            { condition: formData.first_treatment_reason_id === -1, message: '請選擇初步檢傷分類' },
            // { condition: formData.final_injury_category_id === -1, message: '請選擇最終傷病分類' },
            // { condition: formData.second_injury_category_id === -1, message: '請選擇次因' },
            { condition: formData.final_disposition_id === -1, message: '請選擇最終處置' },
        ];

        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }

    // 格式化表單資料
    formatFormData(data) {
        return {
            ...data,
            create_time: this.apiService.shared.formatIosDate(data.create_time),
            first_treatment_date: this.apiService.shared.formatIosDate(data.first_treatment_date),
            photo_url_json: JSON.stringify(data.photo_url_json),
            second_injury_category_id: data.second_injury_reason_id,
        };
    }

    // 檢傷 | 101 搜尋檢傷
    async getFirstTreatmentByMedicalId(parameter) {
        return this.callApi('get', 'getFirstTreatmentByMedicalId', parameter);
    }

    // 檢傷 | 102 新增檢傷
    async addFirstTreatment(parameter, progressEvent = null) {
        return this.callApi('post', 'addFirstTreatment', parameter, progressEvent);
    }

    // 檢傷 | 103 更新檢傷
    async updFirstTreatment(parameter, progressEvent = null) {
        return this.callApi('post', 'updFirstTreatment', parameter, progressEvent);
    }

    // 檢傷 | 104 取得檢傷詳細資料
    async getFirstTreatmentById(parameter) {
        return this.callApi('get', 'getFirstTreatmentById', parameter);
    }
}

export default Ftm;
